declare global {
  interface Window {
    jwplayer: any;
  }
}

let jwplayerLoaded = false;

export async function loadJWPlayer(): Promise<void> {
  if (jwplayerLoaded) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://content.jwplatform.com/libraries/RxdFQeJz.js'; // Replace with your JW Player library URL
    script.async = true;
    script.onload = () => {
      jwplayerLoaded = true;
      window.jwplayer = window.jwplayer || {};
      window.jwplayer.key = 'bmGApSGv'; // Your JW Player key
      resolve();
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
